<template>
  <div class="quickstart-static-block gap-column-xs">
      <img src="/icons/quickstart-panda.svg" class="static-panda">

      <div class="gap-row-1xs hint-text">
          <span class="qrw-label-sm bold v1-grey-6-color w-100">
              {{ $t('quickstart_static.title') }}
          </span>
          <span class="qrw-paragraph-md v1-grey-10-color w-100">
              {{ $t('quickstart_static.pt1') }}
          </span>
          <span class="qrw-paragraph-md v1-grey-10-color w-100">
              {{ $t('quickstart_static.pt2') }}
          </span>
      </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.quickstart-static-block {
    background: var(--v1-grey-2-color);
    border-radius: 8px;

    align-items: center;
}

.static-panda {
    width: 150px;
    height: 150px;
    min-width: 150px;
    max-height: 150px;
    max-width: 150px;
    display: block;
}

.hint-text {
    display: flex;
    align-items: center;
    align-content: center;

    width: 263px;
}
</style>